const toTrimmedLabel = (value) =>
  typeof value === "string" ? value.trim() : "";

export const buildBlockRealtimeWritePayload = ({
  label,
  sessionId,
  timestamp,
}) => {
  const payload = {
    label: toTrimmedLabel(label),
    modified_by: String(sessionId ?? "").toLowerCase(),
  };

  if (timestamp) {
    payload.last_update = timestamp;
  }

  return payload;
};
